import React from "react";
import ShowContainer from "../../../mui/ShowContainer";
import { ENUM_CHAT_TAB } from "../../../common/enums";
import { useAppSelector } from "../../../../store/index.ts";
import useLoginAction from "../../../../hooks/useLoginAction.js";
import { useDispatch } from "react-redux";
import { setShowOnlyMyMes } from "../../../../store/chatSlice.js";
import { useTranslation } from "react-i18next";
import { Switch } from "antd";
import "./only-me-message.scss";
import useDetectKeyboardOpen from "use-detect-keyboard-open";

export default function OnlyMeMessage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const chatActiveTab = useAppSelector((state) => state.chat.chatActiveTab);
  const showOnlyMyMes = useAppSelector((state) => state.chat.showOnlyMyMes);
  const { onLoginAction } = useLoginAction();
  const isKeyboardOpen = useDetectKeyboardOpen();
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);

  const toggleShowMes = () => onLoginAction(() => dispatch(setShowOnlyMyMes(!showOnlyMyMes)));

  const isShowSwitch = !isKeyboardOpen && !isFullScreen && chatActiveTab === ENUM_CHAT_TAB.free;

  return (
    <ShowContainer condition={isShowSwitch} fallback={<div></div>}>
      <button className="switch-my-messages" onClick={toggleShowMes}>
        <label>{t("Show only my messages")}</label>
        <Switch checked={showOnlyMyMes} onChange={toggleShowMes} className="custom-switch" />
      </button>
    </ShowContainer>
  );
}
